import React from "react";

/**
 * MorphingBlob
 * Props:
 *   image {string} – optional image src; if omitted a gray placeholder is shown
 *   alt   {string} – alt text for the image
 */
const MorphingBlob = ({ image, alt = "Portrait" }) => {
  return (
    <div className="morphing-blob-wrapper">
      {/* Main image blob */}
      <div className="blob-main">
        {image ? (
          <img src={image} alt={alt} className="blob-main__img" />
        ) : (
          <div className="blob-main__placeholder" />
        )}
      </div>

      {/* Decorative outline blobs — rendered after so they sit on top */}
      <div className="blob-outline blob-outline--1" aria-hidden="true" />
      <div className="blob-outline blob-outline--2" aria-hidden="true" />
      <div className="blob-outline blob-outline--3" aria-hidden="true" />
    </div>
  );
};

export default MorphingBlob;
